import { useMutation, useQuery } from '@tanstack/react-query'
import { acknowledgeSensorAlert } from '../mutations/sensorAlerts.mutations'
import { fetchActiveAlerts } from '../queries/sensorAlerts.queries'

export const useActiveSensorAlerts = () =>
  useQuery({
    queryKey: ['sensorAlerts'],
    queryFn: () => fetchActiveAlerts(),
  })

export const useAcknowledgeSensorAlert = () =>
  useMutation({
    mutationFn: (id: number) => acknowledgeSensorAlert(id),
  })
